import { Injectable } from "@angular/core";
import { BaseRepository } from "./base.repository";
import { Observable } from "rxjs";

@Injectable({
    providedIn:"root"
})
export class WebEngageRepository extends BaseRepository {
    mapClick(hotelName: string | number): Observable<any> {
        const url = this.baseUrl + `webengage/WebEngageMapClick`
        return this.http.post<any>(url, {HotelName: hotelName})
    }

    filter(filterData: any):Observable<any> {
        const url = this.baseUrl + `webengage/filteredBy`
        return this.http.post(url, filterData)
    }

    reserve(roomData: any):Observable<any> {
        const url = this.baseUrl + `webengage/ActionForReserve`
        return this.http.post(url, roomData)
    }

    review(data: any): Observable<any> {
        const url = this.baseUrl + `webengage/HotelReviewsInHotelInfo`
        return this.http.post(url, data)
    }

    saveDumpingMobile(phoneNumber: string): Observable<any> {
        const url = this.baseUrl + `utm/SaveDumpingMobile`
        return this.http.post(url, {Mobile: phoneNumber})
    }








}
